import { createStyles } from "@material-ui/core";
import { getTheme } from "../Themes";

const theme = getTheme();

export default createStyles({
  appBar: {
    backgroundColor: theme.palette.background.default,
    maxHeight: theme.CatalogManager.dimensions.appBarHeight,
    position: "fixed",
    zIndex: theme.zIndex.drawer + 1,
  },
  hamburger: {
    marginLeft: -12,
    marginRight: 20,
  },
  logo: {
    width: "100%",
  },
  menuFlags: {
    marginRight: theme.spacing.toString(),
  },
  menuItems: {
    display: "block",
    flexGrow: 1,
  },
  menus: {
    display: "flex",
    flexFlow: "column",
    flexWrap: "wrap",
  },
  logoStyle: {
    width: "150px",
    fontSize: "xx-large",
    textTransform: "capitalize",
    padding: "0px",
    fontFamily: "auto",
  },
  profileStyle: {
    color: theme.palette.text.primary,
    paddingRight: 25,
  },
  language: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 14,
    color: theme.palette.text.primary,
  },
  tabItem: {
    "&:hover": {
      color: theme.palette.text.primary,
    },
    color: theme.palette.text.primary,
    opacity: 0.7,
    transition: theme.transitions.create("color"),
  },
  toolbar: {
    justifyContent: "space-between",
    minHeight: "0px",
  },
  switchTheme: {
    width: 0,
    borderRadius: 7,
  },
  version: {
    fontSize: "0.8em",
    opacity: 0.6,
    whiteSpace: "nowrap",
    color: theme.palette.primary.main,
    marginLeft: "-20px",
  },
  tabs: {
    width: "100%",
    justifyContent: "space-between",
  },
  menuPopper: {
    position: "absolute",
    top: "0px",
    left: "-22px",
    transform: "translate3d(444px, 41px, 0px)",
    willChange: "transform",
    width: "160px",
    zIndex: 1203,
  },
});
